import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { OrdenesTransporteItemDto } from './ordenes-transporte-item.dto';

/**
 * DTO para un total individual por moneda.
 */
export class TotalPorMonedaDto {
  @ApiProperty({ description: 'Código de la moneda', example: 'CLP' })
  moneda!: string;

  @ApiProperty({
    description: 'Total de MontoNeto formateado',
    example: '$ 1.500.000 CLP',
  })
  totalMontoNeto!: string;

  @ApiProperty({
    description: 'Total de ExtraCostos formateado',
    example: '$ 250.000 CLP',
  })
  totalExtraCostos!: string;

  @ApiProperty({
    description: 'Total SubTotal formateado',
    example: '$ 1.750.000 CLP',
  })
  totalSubTotal!: string;
}

/**
 * DTO para los totales globales de la consulta.
 */
export class OrdenesTransporteTotalsDto {
  @ApiProperty({
    description: 'Total de MontoNeto formateado',
    example: '$ 1.500.000 CLP',
  })
  totalMontoNeto!: string;

  @ApiProperty({ description: 'Moneda del total de MontoNeto', example: 'CLP' })
  totalMontoNetoMoneda!: string;

  @ApiProperty({
    description: 'Total de ExtraCostos formateado',
    example: '$ 250.000 CLP',
  })
  totalExtraCostos!: string;

  @ApiProperty({
    description: 'Moneda del total de ExtraCostos',
    example: 'CLP',
  })
  totalExtraCostosMoneda!: string;

  @ApiPropertyOptional({
    description: 'Subtotal global formateado',
    example: '$ 1.750.000 CLP',
  })
  totalSubTotal?: string;

  @ApiPropertyOptional({
    description: 'Moneda del subtotal global',
    example: 'CLP',
  })
  totalSubTotalMoneda?: string;

  @ApiProperty({
    description: 'Indica si hay mezcla de monedas en los datos',
    example: false,
  })
  hasMixedCurrencies!: boolean;

  @ApiPropertyOptional({
    description: 'Totales separados por moneda (cuando hay monedas mixtas)',
    type: [TotalPorMonedaDto],
  })
  totalesPorMoneda?: TotalPorMonedaDto[];
}

/**
 * DTO para la respuesta paginada de Órdenes de Transporte.
 *
 * @example
 * ```json
 * {
 *   "data": [...],
 *   "pagination": {
 *     "total": 1669,
 *     "page": 1,
 *     "limit": 10,
 *     "totalPages": 167
 *   },
 *   "totals": {
 *     "totalMontoNeto": 1500000,
 *     "totalMontoNetoMoneda": "CLP",
 *     "totalExtraCostos": 250000,
 *     "totalExtraCostosMoneda": "CLP",
 *     "totalSubTotal": 1750000,
 *     "totalSubTotalMoneda": "CLP",
 *     "hasMixedCurrencies": false
 *   },
 *   "timestamp": "2025-12-04T12:00:00.000Z"
 * }
 * ```
 */
export class OrdenesTransporteResponseDto {
  @ApiProperty({
    description: 'Lista de Órdenes de Transporte',
    type: [OrdenesTransporteItemDto],
  })
  data!: OrdenesTransporteItemDto[];

  @ApiProperty({
    description: 'Información de paginación',
    example: {
      total: 1669,
      page: 1,
      limit: 10,
      totalPages: 167,
    },
  })
  pagination!: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };

  @ApiPropertyOptional({
    description: 'Totales globales calculados en backend',
    type: OrdenesTransporteTotalsDto,
  })
  totals?: OrdenesTransporteTotalsDto;

  @ApiProperty({
    description: 'Timestamp de la respuesta',
    example: '2025-12-04T12:00:00.000Z',
  })
  timestamp!: string;
}
